import * as React from "react";

import { People24Filled, People24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const RuntimeInsightsApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "RuntimeInsights" */ "./RuntimeInsightsApp");
    return { default: namedExport.RuntimeInsightsApp };
});

export const RuntimeInsights: TeamAppConfig = {
    title: "Runtime Insights Hub",
    regularIcon: People24Regular,
    filledIcon: People24Filled,
    description: "The central location for all workload metrics and action items.",
    team: "OSP",
    publicId: "ExchangeOSP",
    owner: "OspOncall@microsoft.com",
    role: "*",
    tags: [],
    app: RuntimeInsightsApp,
    path: "/RuntimeInsights"
};
